<template>
  <div id="component-chat-log" class="m-8" v-show="chatData.length" ref="messagecontainer">
    <vs-button v-show="pagination.current_page > 1" class="mb-4 w-full" @click="loadMore">Carregar Mais...</vs-button>

    <div v-for="(msg, index) in chatData" class="msg-grp-container" :key="index">
      <template v-if="chatData[index - 1]">
        <vs-divider
          v-if="!isSameDay(msg.date || msg.datetime, chatData[index - 1].date || chatData[index - 1].datetime)"
        >
          <span>{{ toDate(msg.date || msg.datetime) }}</span>
        </vs-divider>
        <div class="spacer mt-8" v-if="!hasSentPreviousMsg(chatData[index - 1].type, msg.type)"></div>
      </template>

      <div class="w-full" v-show="index == 0 && dispositivo.status != 'ACTIVE'">
        <div class="vx-col w-full h-full prc-2 mb-base">
          <vx-card slot="no-body" class="text-center h-full bg-primary-gradient greet-user">
            <feather-icon
              icon="AwardIcon"
              class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow"
              svgClasses="h-8 w-8"
            ></feather-icon>
            <h1 class="mb-6 text-white">Aviso Importante</h1>
            <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">
              O restante do conteúdo foi bloqueado por sua conta estar na
              <strong>Versão Gratuita</strong>.
            </p>
            <br />
            <router-link :to="`/planos/mobile/${dispositivo.uid}/1`">
              <vs-button color="warning" type="relief">
                <vs-icon icon-pack="fas" icon="fa-shopping-cart"></vs-icon>&nbsp;Liberar Conteúdo Completo Completo
              </vs-button>
            </router-link>
          </vx-card>
        </div>
      </div>

      <div class="flex items-start" :class="[{ 'flex-row-reverse': msg.type }]" :ref="`message-${index}`">
        <div
          class="msg break-words relative shadow-md rounded py-3 px-4 mb-2 rounded-lg max-w-sm"
          :class="{
            'bg-primary-gradient text-white': msg.type,
            'border border-solid border-grey-light bg-white': !msg.type,
          }"
        >
          <div class="size">
            <span v-html="msg.message"></span>
            <br />
            <span class="time">{{ msg.time | formatTime }} - {{ (msg.date || msg.datetime) | formatDate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
    contacts: {
      type: Array,
      required: true,
    },
    messenger: {
      type: String,
      required: true,
    },
  },
  data: function () {
    return {
      chatData: [],
      pagination: [],
      dispositivo: {
        licence: {
          until: null,
        },
      },
      page: null,
    };
  },
  computed: {
    hasSentPreviousMsg() {
      return (last_sender, current_sender) => last_sender == current_sender;
    },
  },
  watch: {
    contactId: function () {
      this.chatData = [];
      this.loadChat();
    },
  },
  methods: {
    isSameDay(time_to, time_from) {
      const date_time_to = new Date(Date.parse(time_to));
      const date_time_from = new Date(Date.parse(time_from));

      return (
        date_time_to.getFullYear() === date_time_from.getFullYear() &&
        date_time_to.getMonth() === date_time_from.getMonth() &&
        date_time_to.getDate() === date_time_from.getDate()
      );
    },
    toDate(time) {
      const locale = 'pt-br';
      const date_obj = new Date(Date.parse(time));
      const monthName = date_obj.toLocaleString(locale, {
        month: 'long',
      });
      return date_obj.getDate() + ' de ' + monthName.toUpperCase().slice(0, 1) + monthName.toLowerCase().slice(1);
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$parent.$el.scrollTop = this.$parent.$el.scrollHeight;
      });
    },
    scrollToTop() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.$parent.$el.scrollTop = -(this.$parent.$el.scrollHeight - 100);
        }, 0);
      });
    },
    loadMore() {
      if (this.pagination.current_page > 1) {
        this.page = this.pagination.current_page - 1;
        this.loadChat();
      }
    },
    loadChat() {
      this.contacts.forEach((i) => {
        if (i.contactId == this.contactId) {
          i.unread_count = 0;
        }
      });

      const mobile = JSON.parse(this.$localStorage.get('mobile'));
      this.$api
        .get(
          `/api/v${mobile.panel_version}/mobile/${this.messenger}/${mobile.uid}/contact/${this.contactId}?page=${this.page}`
        )
        .then((response) => {
          var scrollToBottom = this.chatData.length ? false : true;
          this.pagination = response.data.meta ? response.data.meta.pagination : {};
          this.chatData = response.data.data.concat(this.chatData);

          if (scrollToBottom) {
            this.scrollToBottom();
          } else {
            this.scrollToTop();
          }
        });

      this.$api.get(`/api/v${mobile.panel_version}/mobile/device/${mobile.uid}`).then((response) => {
        this.dispositivo = response.data.data;
        this.$EventBus.$emit('deviceChanged', this.dispositivo);
      });
    },
  },
  updated() {
    this.scrollToBottom();
  },
  mounted() {
    this.chatData = [];
    this.loadChat();
  },
};
</script>
<style>
.size {
  min-width: 100px;
}
span.time {
  font-size: 11px;
  color: rgba(0, 0, 0, 0.45);
}
</style>
